export class AuditEntryDto {
  constructor(
    public id: string,
    public actorName: string,
    public action: string,
    public projectStage: string,
    public description: string,
    public payload: Record<string, any>,
    public entityId: number | null,
    public entityType: string | null,
    public entityName: string | null,
    public timestamp: string,
  ) {}
}

export interface AuditQueryFilter {
  actorId?: string;
  action?: string;
  stage?: string;
  from?: string;
  to?: string;
  entityId?: string;
}
